// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_FORM_ERRORS = 'formErrors/set-form-errors';
export const CLEAR_FORM_ERRORS = 'formErrors/clear-form-errors';
